"use client"

import BannerWithTracking from "@/components/BannerWithTracking"
import { useBannerResize } from "@/hook/useHomepage"
import { BannerProps, HeaderBannerData } from "@/types/types"
import Image from "next/image"
import React from "react"

const Banner: React.FC<BannerProps & { bannerId?: string }> = ({ data, className = "" }) => {
  const defaultBanner: HeaderBannerData = {
    imageUrl: "/images/banner-header.jpg",
    altText: "Tamda Media",
  }

  // Chỉ dùng data từ SSR hoặc default banner
  const bannerData: HeaderBannerData = data || defaultBanner

  const { containerHeight } = useBannerResize(bannerData.imageUrl)

  const imageContainer = (
    <Image
      src={bannerData.imageUrl}
      alt={bannerData.altText || "Banner"}
      fill
      fetchPriority="high"
      className="object-contain transition-all duration-300 hover:brightness-110"
      sizes="100%"
      priority
    />
  )

  const bannerContent = (
    <div className={`relative w-full mx-auto px-4 sm:px-0 ${className}`}>
      {bannerData.link ? (
        <div className="pointer-events-none flex justify-center">
          <BannerWithTracking
            bannerId={data?.id?.toString() || "header-banner"}
            bannerUrl={bannerData.link}
            trackingConfig={bannerData.trackingConfig}
            className="w-[1128px] pointer-events-auto inline-block"
          >
            <div
              className="relative"
              style={{
                height: containerHeight ? `${containerHeight}px` : "auto",
                width: "100%",
              }}
            >
              {bannerData.imageUrl && imageContainer}
            </div>
          </BannerWithTracking>
        </div>
      ) : (
        <div
          className="relative"
          style={{
            height: containerHeight ? `${containerHeight}px` : "auto",
            width: "100%",
          }}
        >
          {bannerData.imageUrl && imageContainer}
        </div>
      )}
    </div>
  )

  return bannerContent
}

export default Banner
